module.exports = __webpack_public_path__ + "media/images/contact-us/message-icon-d8edfa185c58973cabb3b0c6c8ec31d3.svg";